import axios from '@fuse/utils/axios'

const getAllUser = (params) => axios.get(`/assets/fetch-paginated-users-suggestion?page=${params.page}&column=${params.column ?? 'name'}${params?.client_id ? `&client_id=${params?.client_id}` : ''}&type=${params.type ?? ''}${params.search ? `&search=${params.search}`: ''}`);
const getAllRoles = (params) => axios.get(`/roles/fetch-paginated-role-suggestion?page=${params.page}${params.search ? `&search=${params.search}` : ''}`);
const resendToken = (payload) => axios.post('/user/password/token/reset', payload);

export {
    getAllUser,
    getAllRoles,
    resendToken
}
